export default "__VITE_ASSET__DysJakh2__"